import { GroupExclusionReason } from '@/types/deployment'

export const GROUP_EXCLUSION_REASONS: GroupExclusionReason[] = [
  'blur_enabled',
  'bbox_video',
  'live_output',
  'non_rtsp_source',
  'media_folder',
  'static_batch_model',
  'unsupported_model_type',
  'multiple_milestone_servers',
  'jetson_device',
  'device_not_capable',
  'no_group_image',
  'driver_too_old',
  'groups_disabled'
]

export type GroupExclusionReasonIds = {
  labelId: string
  hintId: string
}

const isKnownReason = (reason: string): reason is GroupExclusionReason =>
  (GROUP_EXCLUSION_REASONS as string[]).includes(reason)

export const getGroupExclusionReasonIds = (
  reason: string
): GroupExclusionReasonIds => {
  const key = isKnownReason(reason) ? reason : 'unknown'

  return {
    labelId: `deployments.plan.reason.${key}.label`,
    hintId: `deployments.plan.reason.${key}.hint`
  }
}
